import { useQuery } from "@tanstack/react-query";
import { Router } from "lucide-react";
import { EmptyState, Skeleton, StatusBadge } from "@finora/ui";
import { api } from "../../lib/api";

const STATUS_TONE: Record<string, "success" | "warning" | "neutral"> = {
  ONLINE: "success",
  PENDING: "warning",
  STALE: "neutral",
};

const STATUS_LABEL: Record<string, string> = {
  ONLINE: "Onlajn",
  PENDING: "Na čekanju",
  STALE: "Neaktivan",
};

export function NetworkDevicesTab() {
  const { data: devices, isLoading } = useQuery({
    queryKey: ["cloud-api-network-devices"],
    queryFn: () => api.listCloudApiNetworkDevices(),
  });

  return (
    <div className="rounded-xl border border-border bg-surface shadow-subtle">
      {isLoading ? (
        <div className="space-y-2 p-5">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-10 w-full" />
          ))}
        </div>
      ) : !devices || devices.length === 0 ? (
        <div className="p-5">
          <EmptyState
            icon={Router}
            title="Nema registrovanih uređaja"
            description="POS/restorani sa dinamičkom IP adresom se ovde pojavljuju nakon prvog register-ip poziva."
          />
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Naziv</th>
              <th>Integracija</th>
              <th>Poslednja IP</th>
              <th>Poslednji heartbeat</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.id}>
                <td className="font-medium text-slate-800">{d.label}</td>
                <td className="text-slate-500">{d.integrationName}</td>
                <td className="font-mono text-xs text-slate-600">{d.lastKnownIp ?? "—"}</td>
                <td className="text-slate-500">
                  {d.lastHeartbeatAt ? new Date(d.lastHeartbeatAt).toLocaleString("sr-RS") : "—"}
                </td>
                <td>
                  <StatusBadge
                    label={STATUS_LABEL[d.status] ?? d.status}
                    tone={STATUS_TONE[d.status] ?? "neutral"}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
